// src/config/app.ts
// Configuration centrale de l'application Zemen

// URL de base pour le partage (web)
export const WEB_BASE_URL = process.env.REACT_APP_WEB_URL || 'https://calendar.evaloqui.ai';

// URLs des stores
export const STORE_URLS = {
    PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.ethiopiancalendar.app',
    APP_STORE: 'https://apps.apple.com/us/app/zemen-calendar/id6759289221',
};

// Deep link scheme
export const DEEP_LINK_SCHEME = 'zemen';

// Configuration des URLs de partage
export const SHARE_CONFIG = {
    // URL de base pour les posts partagés
    WEB_BASE_URL,

    // Générer l'URL de partage d'un post
    getPostShareUrl: (postId: number): string => {
        return `${WEB_BASE_URL}/post/${postId}`;
    },

    // Générer le deep link d'un post (pour ouvrir dans l'app)
    getPostDeepLink: (postId: number): string => {
        return `${DEEP_LINK_SCHEME}://post/${postId}`;
    },

    // URLs des stores
    STORE_URLS,

    // Détecter la plateforme et retourner l'URL du store approprié
    getStoreUrl: (): string => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(userAgent)) {
            return STORE_URLS.APP_STORE;
        }
        return STORE_URLS.PLAY_STORE;
    },
};

export default SHARE_CONFIG;
